const REDUCER_PATH = "referrerService";
const REFERRER_SERVICE_TAG = "Referrer";

const RELATED_TAGS = [REFERRER_SERVICE_TAG];

export { REDUCER_PATH, REFERRER_SERVICE_TAG, RELATED_TAGS };

